import React from "react";
import { Link } from "react-router-dom";

function HeroSection() {
  return (
    <section className="container py-5">
      <div className="row align-items-center">
        <div className="col-lg-6 mb-4 mb-lg-0">
          <h1 className="display-4 fw-bold mb-3">
            Працюй з Uber, Bolt, FreeNow — легко та вигідно
          </h1>
          <p className="lead mb-4">
            Ми — надійний партнер для водіїв у Польщі. Допоможемо заробляти більше та вирішимо бюрократію за вас.
          </p>
          <Link to="/register" className="btn btn-warning btn-lg">
            Почати зараз
          </Link>
        </div>
        <div className="col-lg-6 text-center">
          <img
            src="https://cdn-icons-png.flaticon.com/512/3050/3050525.png"
            alt="Водій таксі"
            className="img-fluid"
            style={{ maxHeight: '300px' }}
          />
        </div>
      </div>
    </section>
  );
}

function AboutSection() {
  return (
    <section className="bg-light py-5">
      <div className="container">
        <h2 className="h3 fw-bold mb-3">Про нас</h2>
        <p>
          Ми — офіційний партнер Uber, Bolt і FreeNow. Обслуговуємо водіїв у всіх великих містах Польщі. Допомагаємо з легалізацією, розрахунками та пропонуємо цілодобову підтримку.
        </p>
      </div>
    </section>
  );
}

function BenefitsSection() {
  return (
    <section className="py-5">
      <div className="container text-center">
        <h2 className="h3 fw-bold mb-4">Переваги роботи з нами</h2>
        <div className="row">
          <div className="col-md-4 mb-4">
            <img
              src="https://cdn-icons-png.flaticon.com/512/2165/2165947.png"
              alt="Виплати"
              className="mb-3"
              style={{ width: "60px" }}
            />
            <h5 className="fw-semibold">Виплати без затримок</h5>
          </div>
          <div className="col-md-4 mb-4">
            <img
              src="https://cdn-icons-png.flaticon.com/512/5974/5974634.png"
              alt="Підтримка"
              className="mb-3"
              style={{ width: "60px" }}
            />
            <h5 className="fw-semibold">Підтримка 7 днів на тиждень</h5>
          </div>
          <div className="col-md-4 mb-4">
            <img
              src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
              alt="Звіти"
              className="mb-3"
              style={{ width: "60px" }}
            />
            <h5 className="fw-semibold">Автоматичні звіти та розрахунки</h5>
          </div>
        </div>
      </div>
    </section>
  );
}

function CTASection() {
  return (
    <section className="bg-warning text-center py-5">
      <div className="container">
        <h2 className="h4 fw-bold mb-3">Приєднатись до партнерської програми</h2>
        <Link to="/register" className="btn btn-dark btn-lg">
          Почати зараз
        </Link>
      </div>
    </section>
  );
}

function FooterSection() {
  return (
    <footer className="bg-dark text-white text-center py-4">
      <div className="container d-flex flex-wrap justify-content-center gap-3">
        <a href="#" className="text-white text-decoration-none">
          Політика конфіденційності
        </a>
        <a href="#" className="text-white text-decoration-none">
          Контакти
        </a>
        <Link to="/login" className="text-white text-decoration-none">
          Увійти
        </Link>
      </div>
    </footer>
  );
}

export default function LandingPage() {
  return (
    <div>
      <HeroSection />
      <AboutSection />
      <BenefitsSection />
      <CTASection />
      <FooterSection />
    </div>
  );
}
